export default function (universalCookies) {
  return {
    type: 'INITIALIZE COOKIES',
    universalCookies: universalCookies
  };
}
